<template>
  <div>
    <el-row type="flex">
      <el-col :lg="20" class="mx-auto">
        <ra-card :header="false">
          <template slot="content">
            <el-form :model="form" label-position="top" ref="verify">
              <el-row type="flex" :gutter="80" class="flex-wrap mb-2">
                <el-col :md="8" :lg="8">
                  <div class="rd-form--section">
                    <h6>Verify Identification Number</h6>
                  </div>
                </el-col>
                <template v-if="step === 1">
                  <el-col :md="16" :lg="16">
                    <el-row type="flex" :gutter="20" class="flex-wrap">
                      <el-col :span="24">
                        <el-form-item
                          label="ID Type"
                          prop="type"
                          :rules="validateField()"
                        >
                          <el-select
                            clearable
                            v-model="form.type"
                            placeholder="Select ID Type"
                          >
                            <el-option
                              v-for="(idType, index) in identityTypes"
                              :key="index"
                              :label="idType.name"
                              :value="idType.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <template v-if="form.type === 'passport/nigeria'">
                      <el-row type="flex">
                        <el-col :span="24">
                          <el-form-item
                            label="First Name"
                            prop="firstName"
                            :rules="validateField()"
                          >
                            <el-input
                              type="text"
                              v-model="form.firstName"
                              placeholder="First Name"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row type="flex">
                        <el-col :span="24">
                          <el-form-item
                            label="Last Name"
                            prop="lastName"
                            :rules="validateField()"
                          >
                            <el-input
                              type="text"
                              v-model="form.lastName"
                              placeholder="Last Name"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row type="flex">
                        <el-col :span="24">
                          <el-form-item
                            label="Date of Birth"
                            prop="dob"
                            :rules="validateField()"
                          >
                            <el-date-picker
                              class="mr-1"
                              v-model="form.dob"
                              value-format="yyyy-MM-dd"
                              placeholder="Date of Birth"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>

                    <el-row type="flex">
                      <el-col :span="24">
                        <el-form-item
                          :label="selectedIdentityType.idLabel"
                          prop="idNumber"
                          :rules="customField(form.type)"
                        >
                          <el-input
                            type="text"
                            v-model="form.idNumber"
                            :placeholder="selectedIdentityType.placeholder"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div class="is-flex is-justify-center">
                      <el-button
                        v-if="userCan('proxy', 'identity.bvn.simple.fetchdata')"
                        type="primary"
                        :loading="loading"
                        @click="verifyIdentity"
                        >Next</el-button
                      >
                    </div>
                  </el-col>
                </template>

                <template v-else-if="step === 2">
                  <el-col :md="16" :lg="16">
                    <el-row type="flex">
                      <el-col :span="24">
                        <el-form-item
                          label="A one-time pin (OTP) has been sent to your phone number"
                          prop="pin"
                          :rules="validateField()"
                        >
                          <el-input
                            type="text"
                            v-model="form.pin"
                            placeholder="Enter OTP"
                            v-only-number
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div class="text-center mb-1">
                      <el-button type="text" @click="step = 1"
                        ><i class="ra-icon--chevron-left"></i> Back</el-button
                      >
                      <el-button
                        type="primary"
                        :loading="loading"
                        @click="verifyOtp"
                        >Verify</el-button
                      >
                    </div>
                    <div class="text-center">
                      <p>
                        Didn't get OTP?
                        <span
                          :class="{
                            'text-cursor': !resendingOtp,
                            'text-opacity': resendingOtp
                          }"
                          class="text-primary"
                          @click="resendOTP"
                          >{{ `Resend${resendingOtp ? "ing" : ""}` }}</span
                        >
                      </p>
                    </div>
                  </el-col>
                </template>
              </el-row>
            </el-form>
          </template>
        </ra-card>
      </el-col>
    </el-row>
    <Verification
      v-if="showVerificationInfo"
      :show.sync="showVerificationInfo"
      :identityType="selectedIdentityType.name"
      :verification="verificationDetails"
    />
  </div>
</template>

<script>
import { resendOtp, getActiveOrganisationWallet } from "@/lib/utils";
import apiConstants from "@/apiConstants";
import Verification from "@/components/Products/VerifyIdentity/Verifications/Verification";

const verifyForm = {
  type: "",
  idNumber: "",
  pin: "",
  firstName: "",
  lastName: "",
  dob: ""
};

const otpForm = {
  pin: "",
  token: ""
};

const defaultIdentityType = {
  idLabel: "ID",
  placeholder: "Enter ID No"
};

export default {
  name: "IdVerification",

  components: {
    Verification
  },

  data() {
    return {
      routes: [
        {
          name: "verify-identity.index",
          label: "Verify Identity"
        },
        {
          name: "verify-identity.verifications",
          label: "Verifications"
        },
        {
          name: "verify-identity.verify",
          label: "Verify Id"
        }
      ],
      loading: false,
      step: 1,
      form: { ...verifyForm },
      otpForm: { ...otpForm },
      identityTypes: apiConstants.IDENTITY_TYPES,
      showVerificationInfo: false,
      verificationDetails: {},
      resendingOtp: false,
      selectedIdentityType: { ...defaultIdentityType },
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  methods: {
    clearForm() {
      this.form = { ...verifyForm };
      this.otpForm = { ...otpForm };
    },

    verifyIdentity() {
      this.$refs.verify.validate(async valid => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        const { firstName, lastName, dob } = this.form;

        let apiUrl = `identity/${this.form.type}/${this.form.idNumber}`;

        if (this.form.type === "passport/nigeria") {
          apiUrl += `?first_name=${firstName}&last_name=${lastName}&dob=${dob}`;
        }

        this.$http
          .post(
            apiUrl,
            {
              method: "GET"
            },
            {
              headers: {
                "data-baseurl-namespace": apiConstants.URLS.SERVICES
              }
            }
          )
          .then(response => {
            this.loading = false;
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              if (resData.type === "response") {
                this.notification(
                  "Verified",
                  "Identity verified successfully",
                  "success"
                );
                this.getWallet();
                this.verificationDetails = resData.data;
                this.showVerificationInfo = true;
              } else if (resData.type === "otp") {
                this.otpForm = { ...otpForm };
                this.otpForm.token = resData.data && resData.data.token;
                this.step = 2;
              } else {
                this.notification(
                  "Error",
                  "An unknown error occurred",
                  "danger"
                );
              }
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    resendOTP() {
      if (!this.otpForm.token) {
        this.notification(
          "Error",
          "Token is not found to resend OTP",
          "danger"
        );
        return;
      }

      if (this.resendingOtp) {
        return;
      }

      this.resendingOtp = true;
      const body = {
        token: this.otpForm.token
      };

      resendOtp(this.$http, body)
        .then(() => {
          this.resendingOtp = false;
          this.notification(
            "OTP",
            "A one-time pin (OTP) has been sent to your phone number",
            "success"
          );
        })
        .catch(err => {
          this.resendingOtp = false;
          this.notification("Error", err.message, "danger");
        });
    },

    verifyOtp() {
      this.otpForm.pin = this.form.pin;
      if (!this.otpForm.pin) {
        this.notification("Error", "OTP can't be blank", "error");
        return;
      }
      this.loading = true;
      this.$http
        .post(
          "authorize",
          {
            body: this.otpForm,
            method: "POST"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          this.loading = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.clearForm();
            this.step = 1;
            this.notification(
              "Verified",
              "Identity verified successfully",
              "success"
            );
            this.getWallet();
            this.verificationDetails = resData;
            this.showVerificationInfo = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    getWallet() {
      if (!this.userCan("payment", "wallet.getall")) {
        return;
      }
      getActiveOrganisationWallet(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  },

  watch: {
    "form.type": function(val) {
      this.clearForm();
      this.selectedIdentityType = this.identityTypes.find(
        it => it.value === val
      ) || { ...defaultIdentityType };
      this.form.type = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.rd-form--section {
  h6 {
    font-size: 1rem;
    font-weight: 500;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -20px;
      transform: translateY(-50%);
      background: var(--primary);
      height: 10px;
      width: 10px;
    }
  }
}
.otp-alert {
  color: #36afa4;
  margin-bottom: 15px;
  font-size: 14px;
}
</style>
